export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/metronome-icon.svg?9bb8edff54f1c5f654940ac123f2c181";